/**
 * Capture a `?tour=<id>` (or `#…tour=<id>`) deep-link parameter at the very
 * first moment of app startup — BEFORE the auth/session bootstrap or the router
 * can strip the query string — and stash it in sessionStorage for GuideMeRoot to
 * pick up once the app has mounted. This is what lets an external link (e.g. the
 * partner-training "Show me in Experience" buttons) open a plugin and auto-start
 * its guided tour, even across an OIDC redirect.
 *
 * Imported as the FIRST import in main.tsx so it runs at module-eval time.
 */
export const PENDING_TOUR_KEY = 'guide-me:pending-tour';
export const PENDING_TOUR_TS_KEY = 'guide-me:pending-tour:ts';

try {
  const search = new URLSearchParams(window.location.search);
  const fromHash = window.location.hash.match(/[?&]tour=([^&]+)/);
  const tourId = search.get('tour') || (fromHash ? fromHash[1] : null);
  if (tourId) {
    const id = decodeURIComponent(tourId);
    // Persist in BOTH storages. sessionStorage is the fast same-tab path;
    // localStorage additionally survives the OIDC login round-trip and any
    // bootstrap reloads (a fresh/incognito session redirects to the IdP and
    // back before Guide Me can mount — sessionStorage does not reliably carry
    // across that, localStorage does). The timestamp lets the consumer ignore a
    // stale pointer so an old link can't silently auto-fire a tour on a later visit.
    try { sessionStorage.setItem(PENDING_TOUR_KEY, id); } catch { /* ignore */ }
    try {
      localStorage.setItem(PENDING_TOUR_KEY, id);
      localStorage.setItem(PENDING_TOUR_TS_KEY, String(Date.now()));
    } catch { /* ignore */ }
    // eslint-disable-next-line no-console
    console.info('[guide-me] captured deep-link tour', id);
    // Strip ?tour= so it does not linger in the URL or re-trigger on refresh.
    search.delete('tour');
    const qs = search.toString();
    const url = window.location.pathname + (qs ? `?${qs}` : '') + window.location.hash;
    window.history.replaceState({}, '', url);
  }
} catch {
  /* non-browser / restricted context — ignore */
}
